import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the PartialPageTitlePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-upload-image',
  templateUrl: 'upload-image.html',
})
export class UploadImagePage {
  @Input() title: string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  public onBack(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/upload-image/upload-image.ts